import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import React from 'react';
import { PlaceholderCommon } from './PlaceholderCommon';
import { withComponentFactory } from '../enhancers/withComponentFactory';
import { HorizonEditor } from '@sitecore-jss/sitecore-jss';
/**
 * @param {HtmlElementRendering | ComponentRendering} rendering
 */
function isRawRendering(rendering) {
  return !rendering.componentName && rendering.name !== undefined;
}
let PlaceholderComponent = /*#__PURE__*/function (_PlaceholderCommon) {
  _inheritsLoose(PlaceholderComponent, _PlaceholderCommon);
  function PlaceholderComponent(props) {
    var _this;
    _this = _PlaceholderCommon.call(this, props) || this;
    _this.isEmpty = false;
    return _this;
  }
  var _proto = PlaceholderComponent.prototype;
  _proto.componentDidMount = function componentDidMount() {
    if (this.isEmpty && HorizonEditor.isActive()) {
      HorizonEditor.resetChromes();
    }
  };
  _proto.render = function render() {
    const childProps = Object.assign({}, this.props);
    delete childProps.componentFactory;
    if (this.state.error) {
      if (childProps.errorComponent) {
        return /*#__PURE__*/React.createElement(childProps.errorComponent, {
          error: this.state.error
        });
      }
      return /*#__PURE__*/React.createElement("div", {
        className: "sc-jss-placeholder-error"
      }, "A rendering error occurred: ", this.state.error.message, ".");
    }
    const renderingData = childProps.rendering;
    const placeholderData = PlaceholderCommon.getPlaceholderDataFromRenderingData(renderingData, this.props.name);
    const components = this.getComponentsForRenderingData(placeholderData);
    this.isEmpty = placeholderData.every(rendering => isRawRendering(rendering));
    if (this.props.renderEmpty && this.isEmpty) {
      return this.props.renderEmpty(components);
    } else if (this.props.render) {
      return this.props.render(components, placeholderData, childProps);
    } else if (this.props.renderEach) {
      const renderEach = this.props.renderEach;
      return components.map((component, index) => {
        if (component && component.props && component.props.type === 'text/sitecore') {
          return component;
        }
        return renderEach(component, index);
      });
    } else {
      return components;
    }
  };
  return PlaceholderComponent;
}(PlaceholderCommon);
export const Placeholder = withComponentFactory(PlaceholderComponent);